import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { HttpError } from '@models/http-error.model';
import { MealPlanModel } from '@models/meal-plan/meal-plan.model';
import { CustomerService } from '@services/customer.service';
import { MealPlanService } from '@services/meal-plan.service';
import { MealmomentService } from '@services/meal-moment.service';
import { TerminalService } from '@services/terminal.service';
import { AppRoutes } from '@helpers/app-routes';
import { FormatPricePipe } from '@pipes/format-price.pipe';

@Component({
  selector: 'app-choose-meal-plan-page',
  imports: [TranslateModule, FormatPricePipe],
  templateUrl: './choose-meal-plan-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'block h-full',
  },
})
export class ChooseMealPlanPageComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly customerService = inject(CustomerService);
  private readonly mealPlanService = inject(MealPlanService);
  private readonly mealmomentService = inject(MealmomentService);
  private readonly terminalService = inject(TerminalService);
  private readonly toastr = inject(ToastrService);
  private readonly translate = inject(TranslateService);

  readonly mealPlans = signal<MealPlanModel[]>([]);
  readonly isLoading = signal(true);

  ngOnInit(): void {
    const customer = this.customerService.currentCustomer();

    if (!customer) {
      void this.router.navigate(['/page-scan']);
      return;
    }

    const enterpriseId = this.terminalService.currentTerminal()!.enterprise_id;

    this.mealPlanService.getMealPlans(customer.id, enterpriseId).subscribe({
      next: (mealPlans) => {
        this.isLoading.set(false);
        const currentMealMomentId = this.mealmomentService.currentMealMoment()?.id;
        this.mealPlans.set(
          mealPlans.filter((mealPlan) => mealPlan.meal_moment.id === currentMealMomentId),
        );
      },
      error: (err: HttpError) => {
        this.isLoading.set(false);
        this.toastr.error(
          this.translate.instant(err.message),
          this.translate.instant('page_choix_formules.errors.load_error_title'),
        );
      },
    });
  }

  selectMealPlan(mealPlan: MealPlanModel): void {
    this.mealPlanService.setMealPlan(mealPlan);
    void this.router.navigate([AppRoutes.order]);
  }
}
